(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-footer.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-footer.js');
"use strict";

var _svs$core$config$data;

const {
  useCallback
} = React;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  ReactButton: Button
} = svs.ui;
const {
  productIds
} = svs.utils.products;
const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  getSystemPrice
} = svs.components.lbUi;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  usePlaceBet,
  helpers: {
    is1X2,
    getNumberOfRows
  }
} = svs.components.sport.quickplayModal;

const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
const SystemInfo = props => {
  var _pixData$signsByEvent;
  const {
    productId,
    pixData,
    systemCost,
    rowPrice,
    isMobile,
    systemType
  } = props;
  const shouldShowHedges = is1X2(productId) && productId !== productIds.CHALLENGE;
  const mobileIconSize = shouldShowHedges ? 100 : 200;
  const notMobileIconSize = shouldShowHedges ? 200 : 300;
  const iconSize = isMobile ? mobileIconSize : notMobileIconSize;
  const game1X2Signs = (pixData === null || pixData === void 0 || (_pixData$signsByEvent = pixData.signsByEventForOutput) === null || _pixData$signsByEvent === void 0 ? void 0 : _pixData$signsByEvent.game1X2) || [];
  const halfHedges = shouldShowHedges ? game1X2Signs.filter(row => row.filter(Boolean).length === 2).length : null;
  const fullHedges = shouldShowHedges ? game1X2Signs.filter(row => row.filter(Boolean).length === 3).length : null;
  const systemPrice = getSystemPrice(pixData && systemType ? pixData.systemCost : systemCost, systemType, productId);
  const rows = getNumberOfRows(pixData && systemType ? pixData.systemCost : systemCost, rowPrice);
  return React.createElement("div", {
    className: "system-info-list f-550 margin-bottom-1 margin-top-half"
  }, Boolean(shouldShowHedges) && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "system-size"
  }, React.createElement(Icon, {
    className: "margin-right-half",
    color: "white",
    icon: "hedge-full",
    size: iconSize
  }), React.createElement("span", {
    className: "f-400 f-bold"
  }, fullHedges), React.createElement(Icon, {
    className: "margin-left-1 margin-right-half",
    color: "white",
    icon: "hedge-half",
    size: isMobile ? mobileIconSize : notMobileIconSize
  }), React.createElement("span", {
    className: "f-400 f-bold"
  }, halfHedges)), React.createElement("span", {
    className: "f-400"
  }, "".concat(formatCurrency(systemPrice), " kr"))), !shouldShowHedges && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "system-size"
  }, React.createElement(Icon, {
    className: "margin-right-1",
    color: "white",
    icon: "rows-three",
    size: iconSize
  }), "Rader:\xA0", React.createElement("span", {
    className: "f-bold"
  }, rows), "\xA0st"), React.createElement("span", null, "".concat(formatCurrency(systemPrice), " kr"))));
};
const QuickplayModalFooter = props => {
  const {
    productId,
    drawData,
    raceData,
    pixData,
    systemCost,
    systemType,
    rowPrice,
    wallet,
    handleClose,
    hasSaveButton,
    competitionBranding
  } = props;
  const systemPrice = getSystemPrice(systemCost, systemType, productId);
  const {
    placeBet
  } = usePlaceBet();
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const _submit = useCallback(() => {
    if (hasSaveButton) {
      handleClose();
    } else {
      placeBet({
        drawData,
        raceData,
        pixData,
        rowPrice,
        wallet,
        closeCallback: handleClose
      });
    }
  }, [hasSaveButton, handleClose, placeBet, drawData, raceData, pixData, rowPrice, wallet]);
  const competitionBrand = competitionBranding && "quickplay-pix-".concat(competitionBranding);
  const pixLogo = React.createElement("div", {
    className: "quickplay-pix-logo no-text-selection"
  }, React.createElement("div", {
    className: "quickplay-pix-container"
  }, React.createElement("div", {
    className: "quickplay-pix-content bg-navy ".concat(isMobile ? 'f-600' : 'f-800', " ").concat(competitionBrand ? competitionBrand : '')
  }, React.createElement("span", {
    className: "f-bold"
  }, "PIX!"), ' ', React.createElement("span", {
    className: "f-normal"
  }, "F\xE4rdiga\xA0spel. Helt\xA0enkelt."))));
  const payFooter = React.createElement("div", {
    className: "padding-2 bg-navy no-text-selection ".concat(competitionBrand ? competitionBrand : '')
  }, React.createElement("div", {
    className: isMobile ? 'f-500' : 'f-600'
  }, React.createElement(SystemInfo, {
    isMobile: isMobile,
    pixData: pixData,
    productId: productId,
    rowPrice: rowPrice,
    systemCost: systemCost,
    systemType: systemType
  })), React.createElement(Button, {
    block: true,
    className: "js-initial-focus ".concat(competitionBrand ? "".concat(competitionBrand, "--pay-btn") : ''),
    "data-testid": "quickplay-modal-pay-button",
    focus: true,
    onClick: _submit,
    size: 300
  }, Boolean(isSelfService) && React.createElement(React.Fragment, null, "L\xE4gg i varukorgen", React.createElement("br", null), "(".concat(systemPrice, " kr)")), !isSelfService && !hasSaveButton && "Betala", hasSaveButton && "Spara"));
  return React.createElement("div", {
    className: "quickplay-modal-footer"
  }, pixLogo, payFooter);
};
SystemInfo.defaultProps = {
  pixData: null
};
QuickplayModalFooter.defaultProps = {
  drawData: null,
  hasSaveButton: false,
  pixData: null,
  raceData: null,
  wallet: null
};
setGlobal('svs.components.sport.quickplayModal', {
  QuickplayModalFooter
});

 })(window);